import React from 'react';

const SparkleIcon = ({ id = 'default' }) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.7">
            <path d="M11.6985 9.62219C7.84504 8.752 7.24815 8.1551 6.37799 4.30155C6.33812 4.12542 6.18135 4 6.00019 4C5.81904 4 5.66227 4.12542 5.6224 4.30155C4.75185 8.1551 4.15535 8.752 0.301926 9.62219C0.125415 9.66245 0 9.81884 0 10C0 10.1812 0.125415 10.3375 0.301926 10.3778C4.15535 11.2484 4.75185 11.8453 5.6224 15.6985C5.66227 15.8746 5.81904 16 6.00019 16C6.18135 16 6.33812 15.8746 6.37799 15.6985C7.24854 11.8453 7.84504 11.2484 11.6985 10.3778C11.875 10.3375 12 10.1812 12 10C12 9.81884 11.8746 9.66245 11.6985 9.62219Z" fill={`url(#paint0_${id})`}/>
            <path d="M15.6965 3.11959C13.635 2.65407 13.3455 2.36463 12.88 0.303467C12.8395 0.125828 12.6821 0 12.4998 0C12.3175 0 12.1601 0.125828 12.1196 0.303467C11.6541 2.36463 11.3646 2.65407 9.30347 3.11959C9.12583 3.16011 9 3.31749 9 3.49981C9 3.68212 9.12583 3.8395 9.30347 3.88002C11.3646 4.34554 11.6541 4.63498 12.1196 6.69653C12.1601 6.87378 12.3175 7 12.4998 7C12.6821 7 12.8395 6.87378 12.88 6.69653C13.3455 4.63498 13.635 4.34554 15.6965 3.88002C15.8738 3.8395 16 3.68212 16 3.49981C16 3.31749 15.8738 3.16011 15.6965 3.11959Z" fill={`url(#paint1_${id})`}/>
        </g>
        <defs>
            <linearGradient id={`paint0_${id}`} x1="-4.47035e-08" y1="10" x2="11.0143" y2="16" gradientUnits="userSpaceOnUse">
                <stop stopColor="#2766AA"/>
                <stop offset="1" stopColor="#0752B0"/>
            </linearGradient>
            <linearGradient id={`paint1_${id}`} x1="9" y1="3.5" x2="15.425" y2="7" gradientUnits="userSpaceOnUse">
                <stop stopColor="#2766AA"/>
                <stop offset="1" stopColor="#0752B0"/>
            </linearGradient>
        </defs>
    </svg>
);

const PageTitle = ({ title, badge }) => (
    <div className="flex flex-col gap-0 mb-4">
        <h2 className="text-[#505050] text-[24px] font-semibold font-heading">{title}</h2>
        <div className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-[#D0E7FF]/20 rounded-full outline outline-1 outline-[#78B3F3] w-fit -mt-3">
            <SparkleIcon id={title.replace(/\s/g, '')} />
            <span className="text-[#2766AA] text-sm font-semibold font-sans opacity-70">
                {badge}
            </span>
        </div>
    </div>
);

export default PageTitle;
